export default "__VITE_ASSET__D$RHIve3__"